export const inputHtmlAttributes = [
    "accept", "alt", "autoComplete", "autoFocus", "checked", "dir",
    "disabled", "form", "formAction", "formEncType", "formMethod",
    "formNoValidate", "formTarget", "height", "label", "list", "max",
    "maxLength", "min", "multiple", "name", "pattern", "placeholder", "readOnly", "required",
    "size", "src", "step", "type", "value", "width", "acceptCharset",
    "accessKey", "action", "allowFullScreen",
    "allowTransparency", "async", "autoPlay", "capture", "cellPadding",
    "cellSpacing", "challenge", "charSet", "cite", "classID", "className",
    "colSpan", "cols", "content", "contentEditable", "contextMenu", "controls",
    "coords", "crossOrigin", "data", "dateTime", "default", "defer", "download",
    "draggable", "encType", "frameBorder", "headers", "hidden", "high", "href",
    "hrefLang", "htmlFor", "httpEquiv", "icon", "id", "inputMode", "integrity",
    "is", "keyParams", "keyType", "kind", "lang", "loop", "low", "manifest",
    "marginHeight", "marginWidth", "media", "mediaGroup", "method", "minLength",
    "muted", "noValidate", "nonce", "open", "optimum", "poster", "preload",
    "profile", "radioGroup", "rel", "reversed", "role", "rowSpan", "rows",
    "sandbox", "scope", "scoped", "scrolling", "seamless", "selected", "shape",
    "sizes", "span", "spellCheck", "srcDoc", "srcLang", "srcSet", "start", "step",
    "style", "summary", "tabIndex", "target", "title", "type", "useMap", "wmode",
    "wrap"
]
export const eventHtmlAttributes = [
    "onCopy", "onCut",
    "onPast", "onKeyDown", "onKeyPress", "onKeyUp", "onCompositionEnd",
    "onCompositionStart", "onCompositionUpdate", "onFocus", "onBlur",
    "onChange", "onInput", "onSubmit", "onInput", "onClick", "onContextMenu",
    "onDoubleClick", "onDrag", "onDragEnd", "onDragEnter", "onDragExit",
    "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onMouseDown",
    "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseOut",
    "onMouseOver", "onMouseUp", "onSelect", "onAbort", "onCanPlay",
    "onCanPlayThrough", "onDurationChange", "onEmptied", "onEncrypted",
    "onEnded", "onError", "onLoadedData", "onLoadedMetadata",
    "onLoadStart", "onPause", "onPlay", "onPlaying", "onProgress",
    "onRateChange", "onSeeked", "onSeeking", "onStalled", "onSuspend",
    "onTimeUpdate", "onVolumeChange", "onWaiting", "onLoad", "onError",
    "onAnimationStart", "onAnimationEnd", "onAnimationIteration",
    "onTransitionEnd"
]



// WEBPACK FOOTER //
// ./src/behaviours/input-component/react-html-attributes.js